import { useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';

/**
 * Returns MUI breakpoint "down" matches in a single hook call.
 * isSm = viewport is down('sm'), isMd = down('md'), etc.
 * Use this instead of multiple useMediaQuery(theme.breakpoints.down(...)) calls.
 */
export function useBreakpointsDown() {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const isLg = useMediaQuery(theme.breakpoints.down('lg'));
  const isXl = useMediaQuery(theme.breakpoints.down('xl'));
  return useMemo(() => ({ isSm, isMd, isLg, isXl }), [isSm, isMd, isLg, isXl]);
}
